import React, { Component } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import SwalServices from '../../services/swalServices/SwalServices';
import AdminServices from '../../services/axiosServices/apiServices/adminServices';
import { Navigate } from "react-router-dom";
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Dropdown } from 'primereact/dropdown';
import moment from 'moment';
import { getAuthProps } from '../../utils/AuthenticationLibrary';
import { APIURL, DownloadCV, GetDynamicFormPreview, GetScoreFormPreview, GetSubmittedFormPreview, PreviewCV } from '../../services/axiosServices/ApiEndPoints';
import { createRef } from 'react';

export default class SubmittedForms extends Component {
    constructor(props) {
        super(props);
        this.swalServices = new SwalServices();
        this.adminServices = new AdminServices();
        this.dt = createRef();
        this.state = {
            submittedFormsList: [],
            downloadingIds: [],
            route: null,
            isLoading: false,
            dateRange: null,
            totalRecords: 0,
            formList: [],
            formDropdownType: 3,
            searchTimeout: null,
            dateTimeout: null,
            isMergingPdf: false,
            filterDetails: {
                start: 0,
                length: 50,
                search: '',
                formId: '',
                sortField: '',
                sortOrder: 'asc',
                startDate: '',
                endDate: '',
                formType: 'regular'
            }
        };
        this.exportCSV = this.exportCSV.bind(this);
        this.exportPdf = this.exportPdf.bind(this);
        this.exportExcel = this.exportExcel.bind(this);
        this.saveAsExcelFile = this.saveAsExcelFile.bind(this);

    }

    componentDidMount() {
        this.submittedForms();
        this.getFormsList();
    }

    componentWillUnmount() {
        // Clear the timeout when component unmounts to prevent memory leaks
        if (this.state.searchTimeout) {
            clearTimeout(this.state.searchTimeout);
        }
        if (this.state.dateTimeout) {
            clearTimeout(this.state.dateTimeout);
        }
    }

    submittedForms = () => {
        let filterDetials = this.state.filterDetails;
        this.setState({ isLoading: true })
        let request = [filterDetials.start,
        filterDetials.length,
        filterDetials.search,
        filterDetials.formId || 0,
        filterDetials.sortField,
        filterDetials.sortOrder,
        filterDetials.startDate ? moment(filterDetials.startDate).format('YYYY-MM-DD HH:mm:ss') : '',
        filterDetials.endDate ? moment(filterDetials.endDate).format('YYYY-MM-DD HH:mm:ss') : '',
        filterDetials.formType,
        filterDetials.timesheetExpense || 0,
        filterDetials.isFormApproved || 0,
        ];
        this.adminServices.submittedForms(request).then((response) => {
            if (response && response.data && response !== null) {
                let res = response.data?.data || [];
                const total = response.data?.totalRecords || 0;

                res.map((x, index) => {
                    x.srNo = index + 1
                })

                this.setState({
                    submittedFormsList: res,
                    totalRecords: total,
                    isLoading: false
                });
            }
        });

    }

    getFormsList = () => {
        let filterDetails = this.state.filterDetails;
        this.setState({ isLoading: true });

        let request = [this.state.formDropdownType, filterDetails.start, filterDetails.length, filterDetails.search, filterDetails.sortField, filterDetails.sortOrder];

        this.adminServices.getAllForms(request).then((response) => {
            if (response && response.data) {
                let res = response.data.map(form => ({
                    label: form.formname,
                    value: form.formid
                }));
                this.setState({ formList: res, isLoading: false });
            } else {
                this.setState({ isLoading: false });
            }
        });
    };

    handleSearch = (value) => {
        // Clear the previous timeout if it exists
        if (this.state.searchTimeout) {
            clearTimeout(this.state.searchTimeout);
        }

        // Update the search value immediately in state for UI responsiveness
        let details = this.state.filterDetails;
        details.search = value;
        this.setState({ filterDetails: details });

        // Set a new timeout to call the API after 2 seconds of no typing
        const timeout = setTimeout(() => {
            this.submittedForms();
        }, 1500);

        // Store the timeout ID in state
        this.setState({ searchTimeout: timeout });
    }

    handleFormFilter = (value) => {
        let details = this.state.filterDetails
        details.formId = value;
        this.setState({ filterDetails: details }, () => {
            this.submittedForms();
        });
    }

    handleChangeDateRange = (value) => {
        let details = this.state.filterDetails

        if (!value) {
            details.startDate = '';
            details.endDate = '';
            this.setState({ filterDetails: details, dateRange: null }, () => {
                if (this.state.dateTimeout) {
                    clearTimeout(this.state.dateTimeout);
                }
                const timeout = setTimeout(() => {
                    this.submittedForms();
                }, 1000);
                this.setState({ dateTimeout: timeout });
            });
            return;
        }

        if (value[0]) {
            details.startDate = value[0];
        } else {
            details.startDate = '';
        }

        if (value[1]) {
            details.endDate = value[1];
        } else {
            details.endDate = '';
        }

        this.setState({ filterDetails: details, dateRange: value }, () => {
            if (this.state.filterDetails.startDate && this.state.filterDetails.endDate) {
                if (this.state.dateTimeout) {
                    clearTimeout(this.state.dateTimeout);
                }
                const timeout = setTimeout(() => {
                    this.submittedForms();
                }, 1000);
                this.setState({ dateTimeout: timeout });
            }
        });
    }

    resetFilter = () => {
        let details = this.state.filterDetails
        details.search = '';
        details.formId = '';
        details.startDate = '';
        details.endDate = '';
        this.setState({ filterDetails: details, dateRange: null }, () => {
            this.submittedForms()
        });
    }

    onPageChange = (event) => {
        let details = this.state.filterDetails
        details.start = event.first;
        details.length = event.rows;
        this.setState({ filterDetails: details }, () => {
            this.submittedForms();
        })
    };

    onSortChange = (event) => {
        const filterDetails = { ...this.state.filterDetails };
        filterDetails.sortField = event.sortField;
        filterDetails.sortOrder = event.sortOrder === 1 ? 'asc' : 'desc';
        this.setState({ filterDetails }, () => {
            this.submittedForms();
        });
    };

    formTypeBodyTemplate = (rowData) => {
        return (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span>{rowData.formname}</span>
                {rowData.formtype === 'score' && (
                    <span style={{ fontSize: '11px', color: '#ea580c', fontWeight: '500', marginTop: '2px' }}>Assessment</span>
                )}
            </div>
        );
    };

    actionBodyTemplate = (rowData) => {
        const isDownloading = this.state.downloadingIds.includes(rowData.id);
        return (
            <div className="flex gap-2 justify-center items-center">
                <Button
                    icon="pi pi-eye"
                    className="p-button-rounded p-button-text p-button-sm"
                    style={{ width: '2rem', height: '2rem', padding: 0 }}
                    onClick={() => this.handlePreviewPDF(rowData)}
                    tooltip="Preview PDF"
                    tooltipOptions={{ position: 'top' }}
                />
                {/* <Button
                    icon="pi pi-download"
                    className="p-button-rounded p-button-text p-button-sm"
                    style={{ width: '2rem', height: '2rem', padding: 0 }}
                    onClick={() => this.handleDownloadPDF(rowData)}
                    tooltip="Download PDF"
                    tooltipOptions={{ position: 'top' }}
                /> */}
                {
                    isDownloading ? (
                        <div style={{ width: '2rem' }}>
                            <ProgressSpinner style={{ width: '60%', height: '60%' }} strokeWidth="4" />
                        </div>
                    ) : (
                        <Button
                            icon="pi pi-download"
                            className="p-button-rounded p-button-text p-button-sm"
                            style={{ width: '2rem', height: '2rem', padding: 0 }}
                            onClick={() => this.handleDownloadPDF(rowData)}
                            tooltip="Download PDF"
                            tooltipOptions={{ position: 'top' }}
                        />
                    )
                }
            </div>
        );
    };

    handlePreviewPDF = async (rowData) => {
        const formId = rowData.id;
        const loginUser = getAuthProps();
        const token = loginUser.token;

        let url = "";
        if (rowData.formtype === 'score') {
            url = `${APIURL}${GetScoreFormPreview}/${formId}/0`;
        } else if (rowData.isdynamic) {
            url = `${APIURL}${GetDynamicFormPreview}/${formId}/0`;
        } else {
            url = `${APIURL}${GetSubmittedFormPreview}/${formId}/0`;
        }

        try {
            const response = await fetch(url, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            if (response.ok === true) {
                const blob = await response.blob();
                const fileURL = URL.createObjectURL(blob);
                window.open(fileURL, '_blank');
            } else {
                this.swalServices.Error('File not found')
            }
        } catch (err) {
            console.error('Error opening PDF', err);
        }
    };

    handleDownloadPDF = async (rowData) => {
        const formId = rowData.id;
        const loginUser = getAuthProps();
        const token = loginUser.token;

        this.setState(prevState => ({
            downloadingIds: [...prevState.downloadingIds, formId]
        }));

        let url = "";
        if (rowData.formtype === 'score') {
            url = `${APIURL}${GetScoreFormPreview}/${formId}/1`;
        } else if (rowData.isdynamic) {
            url = `${APIURL}${GetDynamicFormPreview}/${formId}/1`;
        } else {
            url = `${APIURL}${GetSubmittedFormPreview}/${formId}/1`;
        }

        try {
            const response = await fetch(url, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            if (response.ok === true) {
                const blob = await response.blob();
                const downloadUrl = URL.createObjectURL(blob);

                const link = document.createElement('a');
                link.href = downloadUrl;

                let filename = rowData.formname;
                link.download = filename
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                URL.revokeObjectURL(downloadUrl);
            } else {
                this.swalServices.Error('File not found')
            }
        } catch (err) {
            console.error('Download failed', err);
        } finally {
            // Remove from downloadingIds
            this.setState(prevState => ({
                downloadingIds: prevState.downloadingIds.filter(id => id !== formId)
            }));
        }

    };

    // exportCSV(selectionOnly) {
    //     if (this.dt.current) {
    //         this.dt.current.exportCSV({ selectionOnly });
    //     }
    // }

    exportCSV(selectionOnly) {
        // Check if a form is selected from dropdown
        if (this.state.filterDetails.formId) {
            // Check if it's a dynamic form (formId > 10 digits)
            const isDynamicForm = this.isDynamicForm(this.state.filterDetails.formId);

            if (isDynamicForm) {
                this.exportDynamicFormCSVData();
            } else {
                this.exportStaticFormCSVData();
            }
        } else {
            // Use current behavior when no form is selected
            this.exportCurrentCSVData(selectionOnly);
        }
    }

    // Current CSV export behavior (when no form is selected)
    exportCurrentCSVData(selectionOnly) {
        if (this.dt.current) {
            const data = selectionOnly ? this.dt.current.props.value.filter(row => this.dt.current.isSelected(row)) : this.dt.current.props.value;

            let csv = '';
            let columns = this.dt.current.props.children;

            columns = columns.filter(col => col.props.header !== 'Actions');
            csv += columns.map(col => col.props.header).join(',') + '\n';

            data.forEach(rowData => {
                const row = columns.map(col => {
                    const field = col.props.field;
                    return '"' + (rowData[field] !== undefined ? rowData[field] : '') + '"';
                });
                csv += row.join(',') + '\n';
            });

            const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            const filename = 'Submitted Forms.csv';

            if (navigator.msSaveBlob) {
                navigator.msSaveBlob(blob, filename);
            } else {
                const url = URL.createObjectURL(blob);
                link.href = url;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
    }

    // Export static form data using the new API when form is selected
    async exportStaticFormCSVData() {
        try {
            this.setState({ isLoading: true });

            // Get the current visible submissions (based on pagination)
            const visibleSubmissions = this.state.submittedFormsList;

            if (visibleSubmissions.length === 0) {
                this.swalServices.Error('No data to export');
                this.setState({ isLoading: false });
                return;
            }

            // Prepare data for API call - array of objects with uniqueKey and submissionId
            const submissionDataArray = visibleSubmissions.map(submission => ({
                uniqueKey: this.state.filterDetails.formId,
                submissionId: submission.id
            }));

            // Call API with array of submission data
            const response = await this.adminServices.getSubmittedFormDetailedData(submissionDataArray);

            if (!response.data.length) {
                this.swalServices.Error('Failed to fetch detailed data');
                this.setState({ isLoading: false });
                return;
            }

            const apiData = response.data;

            // Process the response data
            const processedData = this.processDetailedData(apiData);

            // Check if any data has array fields (like expenseList)
            const hasArrayFields = processedData.some(item =>
                Object.values(item).some(value => Array.isArray(value))
            );

            if (hasArrayFields) {
                // Flatten array fields and create CSV with proper structure
                const { flattenedData, columns, arrayColumns } = this.flattenArrayFields(processedData);
                this.createCSVWithArrayFields(flattenedData, columns, arrayColumns);
            } else {
                // Use simple CSV for static form data
                this.createStaticFormCSV(processedData);
            }

            this.setState({ isLoading: false });

        } catch (error) {
            console.error('Error exporting detailed CSV data:', error);
            this.swalServices.Error('Failed to export detailed data');
            this.setState({ isLoading: false });
        }
    }

    // Export dynamic form data using the new API when dynamic form is selected
    async exportDynamicFormCSVData() {
        try {
            this.setState({ isLoading: true });

            // Get the current visible submissions (based on pagination)
            const visibleSubmissions = this.state.submittedFormsList;

            if (visibleSubmissions.length === 0) {
                this.swalServices.Error('No data to export');
                this.setState({ isLoading: false });
                return;
            }

            // Prepare data for API call - array of objects with uniqueKey and submissionId
            const submissionDataArray = visibleSubmissions.map(submission => ({
                uniqueKey: this.state.filterDetails.formId,
                submissionId: submission.id
            }));

            // Call API with array of submission data
            const response = await this.adminServices.getSubmittedFormDetailedData(submissionDataArray);

            if (!response.data.length) {
                this.swalServices.Error('Failed to fetch detailed data');
                this.setState({ isLoading: false });
                return;
            }

            const apiData = response.data;

            // Process the dynamic form data
            const processedData = this.processDynamicFormData(apiData);

            // Create CSV with dynamic form structure
            this.createDynamicFormCSV(processedData);

            this.setState({ isLoading: false });

        } catch (error) {
            console.error('Error exporting dynamic form CSV data:', error);
            this.swalServices.Error('Failed to export dynamic form data');
            this.setState({ isLoading: false });
        }
    }

    // Create CSV for static forms - exact same structure as Excel
    createStaticFormCSV(processedData) {
        if (!processedData || processedData.length === 0) {
            this.swalServices.Error('No data to export');
            return;
        }

        // Get column headers from the first data item
        const headers = Object.keys(processedData[0] || {});
        
        let csv = '';
        
        // Add header row
        csv += headers.map(header => `"${header}"`).join(',') + '\n';

        // Add data rows
        processedData.forEach(rowData => {
            const row = headers.map(header => {
                const value = rowData[header];
                // Include actual base64 data for signatures (same as Excel)
                if (this.isBase64Image(value)) {
                    return `"${value}"`; // Include the full base64 data
                }
                return `"${value !== undefined ? value : ''}"`;
            });
            csv += row.join(',') + '\n';
        });

        // Create and download CSV file
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const filename = 'Static Form Data.csv';

        if (navigator.msSaveBlob) {
            navigator.msSaveBlob(blob, filename);
        } else {
            const url = URL.createObjectURL(blob);
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }

    // Create CSV for dynamic forms - exact same structure as Excel
    createDynamicFormCSV(processedData) {
        const { questions, submissions, formInfo, sectionDescriptions } = processedData;

        let csv = '';

        // Add form information section at the top (same as Excel)
        csv += '"FORM INFORMATION"\n';
        csv += `"Form Name:","${formInfo.formName || ''}"\n`;
        csv += `"Form Description:","${formInfo.description || ''}"\n`;
        csv += `"Total Submissions:","${submissions.length}"\n`;
        csv += '\n';

        // Add section information (same as Excel)
        csv += '"SECTION INFORMATION"\n';
        Object.keys(sectionDescriptions).forEach(sectionName => {
            csv += `"${sectionName}:","${sectionDescriptions[sectionName]}"\n`;
        });
        csv += '\n';

        // Create header rows (same structure as Excel)
        const headerRow1 = []; // Section names
        const headerRow2 = []; // Questions

        // Add basic columns
        headerRow1.push('Name', 'Email');
        headerRow2.push('', ''); // Empty cells under basic column headers

        // Group questions by section
        const sectionGroups = {};
        questions.forEach(question => {
            if (!sectionGroups[question.sectionName]) {
                sectionGroups[question.sectionName] = [];
            }
            sectionGroups[question.sectionName].push(question);
        });

        // Add section and question headers
        Object.keys(sectionGroups).forEach(sectionName => {
            const sectionQuestions = sectionGroups[sectionName];
            const sectionSpan = sectionQuestions.length;

            // Add section name spanning across its questions
            headerRow1.push(sectionName);
            for (let i = 1; i < sectionSpan; i++) {
                headerRow1.push('');
            }

            // Add question names under the section
            sectionQuestions.forEach(question => {
                headerRow2.push(question.question);
            });
        });

        // Add headers to CSV
        csv += headerRow1.map(header => `"${header}"`).join(',') + '\n';
        csv += headerRow2.map(header => `"${header}"`).join(',') + '\n';

        // Add data rows (same as Excel)
        submissions.forEach((submission, rowIndex) => {
            const dataRow = [];

            // Add basic data
            dataRow.push(submission.name, submission.email);

            // Add answers for all questions in order
            questions.forEach(question => {
                const answer = submission[question.key];

                // Check if the answer is a signature (base64 image) - same as Excel
                if (this.isBase64Image(answer)) {
                    dataRow.push(answer); // Include the full base64 data
                } else {
                    dataRow.push(answer);
                }
            });

            csv += dataRow.map(value => `"${value !== undefined ? value : ''}"`).join(',') + '\n';
        });

        // Create and download CSV file
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const filename = 'Dynamic Form Data.csv';

        if (navigator.msSaveBlob) {
            navigator.msSaveBlob(blob, filename);
        } else {
            const url = URL.createObjectURL(blob);
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }

    // Create CSV with array fields - exact same structure as Excel
    createCSVWithArrayFields(flattenedData, columns, arrayColumns) {
        if (!flattenedData || flattenedData.length === 0) {
            this.swalServices.Error('No data to export');
            return;
        }

        let csv = '';

        // Create header rows (same structure as Excel)
        const headerRow1 = [];
        const headerRow2 = [];

        // Add non-array columns to both header rows
        columns.forEach(col => {
            if (!arrayColumns.includes(col)) {
                headerRow1.push(col);
                headerRow2.push('');
            }
        });

        // Add array column headers
        arrayColumns.forEach(arrayCol => {
            headerRow1.push(arrayCol);
            headerRow2.push(''); // Will be filled with property names
        });

        // Add property names for array columns in row 2
        let colIndex = columns.length - arrayColumns.length + 1;
        arrayColumns.forEach(arrayCol => {
            const maxLength = Math.max(...flattenedData.map(item =>
                Array.isArray(item[arrayCol]) ? item[arrayCol].length : 0
            ));

            for (let i = 0; i < maxLength; i++) {
                if (i === 0) {
                    headerRow2[colIndex - 1] = `${arrayCol} ${i + 1}`;
                } else {
                    headerRow2.push(`${arrayCol} ${i + 1}`);
                }
            }
            colIndex += maxLength;
        });

        // Add headers to CSV
        csv += headerRow1.map(header => `"${header}"`).join(',') + '\n';
        csv += headerRow2.map(header => `"${header}"`).join(',') + '\n';

        // Add data rows (same as Excel)
        flattenedData.forEach(rowData => {
            const row = [];
            headerRow2.forEach(header => {
                const value = rowData[header];
                // Include actual base64 data for signatures (same as Excel)
                if (this.isBase64Image(value)) {
                    row.push(`"${value}"`); // Include the full base64 data
                } else {
                    row.push(`"${value !== undefined ? value : ''}"`);
                }
            });
            csv += row.join(',') + '\n';
        });

        // Create and download CSV file
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const filename = 'Submitted Forms with Array Fields.csv';

        if (navigator.msSaveBlob) {
            navigator.msSaveBlob(blob, filename);
        } else {
            const url = URL.createObjectURL(blob);
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }

    getExportColumns() {
        return this.state.submittedFormsList.map((col) => ({ title: 'ABC', dataKey: 'XYZ' }));
    }

    exportPdf() {
        import('jspdf').then((jsPDF) => {
            import('jspdf-autotable').then(() => {
                const doc = new jsPDF.default(0, 0);
                const exportColumns = this.getExportColumns();
                doc.autoTable(exportColumns, this.state.submittedFormsList);
                doc.save('Submitted Forms.pdf');
            });
        });
    }

    saveAsExcelFile(buffer, fileName) {
        import('file-saver').then((module) => {
            if (module && module.default) {
                let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
                let EXCEL_EXTENSION = '.xlsx';
                const data = new Blob([buffer], { type: EXCEL_TYPE });

                module.default.saveAs(data, "Submitted Forms" + EXCEL_EXTENSION);
            }
        });
    }

    exportExcel() {
        // Check if a form is selected from dropdown
        if (this.state.filterDetails.formId) {
            // Check if it's a dynamic form (formId > 10 digits)
            const isDynamicForm = this.isDynamicForm(this.state.filterDetails.formId);

            if (isDynamicForm) {
                this.exportDynamicFormExcelData();
            } else {
                this.exportStaticFormExcelData();
            }
        } else {
            // Use current behavior when no form is selected
            this.exportCurrentExcelData();
        }
    }

    // Check if form is dynamic (formId > 10 digits)
    isDynamicForm(formId) {
        return formId.toString().length > 10;
    }

    // Export static form data using the new API when form is selected
    async exportStaticFormExcelData() {
        try {
            this.setState({ isLoading: true });

            // Get the current visible submissions (based on pagination)
            const visibleSubmissions = this.state.submittedFormsList;

            if (visibleSubmissions.length === 0) {
                this.swalServices.Error('No data to export');
                this.setState({ isLoading: false });
                return;
            }

            // Prepare data for API call - array of objects with uniqueKey and submissionId
            const submissionDataArray = visibleSubmissions.map(submission => ({
                uniqueKey: this.state.filterDetails.formId,
                submissionId: submission.id
            }));

            // Call API with array of submission data
            const response = await this.adminServices.getSubmittedFormDetailedData(submissionDataArray);

            if (!response.data.length) {
                this.swalServices.Error('Failed to fetch detailed data');
                this.setState({ isLoading: false });
                return;
            }

            const apiData = response.data;

            // if (apiData.length === 0) {
            //     this.swalServices.Error('No detailed data available for export');
            //     this.setState({ isLoading: false });
            //     return;
            // }

            // Process the response data
            const processedData = this.processDetailedData(apiData);

            // Check if any data has array fields (like expenseList)
            const hasArrayFields = processedData.some(item =>
                Object.values(item).some(value => Array.isArray(value))
            );

            if (hasArrayFields) {
                // Flatten array fields and create Excel with merged headers
                const { flattenedData, columns, arrayColumns } = this.flattenArrayFields(processedData);
                this.createExcelWithMergedHeadersExcelJS(flattenedData, columns, arrayColumns);
            } else {
                // Use ExcelJS for simple static form data
                this.createStaticFormExcelJS(processedData);
            }

            this.setState({ isLoading: false });

        } catch (error) {
            console.error('Error exporting detailed Excel data:', error);
            this.swalServices.Error('Failed to export detailed data');
            this.setState({ isLoading: false });
        }
    }

    // Process the detailed data from API response
    processDetailedData(apiData) {
        return apiData.map(item => {
            const processedItem = {
                submissionId: item.submissionId,
                uniqueKey: item.uniqueKey
            };

            // Extract data from nested structure
            if (item.data && item.data.data) {
                const formData = item.data.data;

                // Convert all keys to capital case and add to processed item
                Object.keys(formData).forEach(key => {
                    if (key !== 'signature') { // Ignore signature column as requested
                        const capitalizedKey = this.capitalizeFirstLetter(key);
                        processedItem[capitalizedKey] = formData[key];
                    }
                });
            }

            return processedItem;
        });
    }

    // Utility function to capitalize first letter
    capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    // Utility function to check if a value is a base64 image
    isBase64Image(value) {
        if (!value || typeof value !== 'string') return false;

        // Check if it's a base64 string and looks like an image
        const base64Pattern = /^data:image\/(png|jpg|jpeg|gif|bmp|webp);base64,/i;
        return base64Pattern.test(value) || (value.length > 100 && value.includes('data:image'));
    }

    // Helper function to create a clickable signature cell
    createSignatureCell(worksheet, row, col, signatureData, submissionId, questionText) {
        const cell = worksheet.getCell(row, col);

        // Set the cell value to the signature data
        cell.value = signatureData;
        cell.font = {
            color: { argb: 'FF0066CC' },
            bold: true,
            size: 10
        };

        // Add helpful note
        cell.note = `SIGNATURE DATA for ${questionText}:\n\n1. Click on this cell\n2. Press Ctrl+A to select all\n3. Press Ctrl+C to copy\n4. Open your browser\n5. Paste in address bar\n6. Press Enter to view signature\n\nSubmission ID: ${submissionId}`;

        return cell;
    }


    // Export dynamic form data using the new API when dynamic form is selected
    async exportDynamicFormExcelData() {
        try {
            this.setState({ isLoading: true });

            // Get the current visible submissions (based on pagination)
            const visibleSubmissions = this.state.submittedFormsList;

            if (visibleSubmissions.length === 0) {
                this.swalServices.Error('No data to export');
                this.setState({ isLoading: false });
                return;
            }

            // Prepare data for API call - array of objects with uniqueKey and submissionId
            const submissionDataArray = visibleSubmissions.map(submission => ({
                uniqueKey: this.state.filterDetails.formId,
                submissionId: submission.id
            }));

            // Call API with array of submission data
            const response = await this.adminServices.getSubmittedFormDetailedData(submissionDataArray);

            if (!response.data.length) {
                this.swalServices.Error('Failed to fetch detailed data');
                this.setState({ isLoading: false });
                return;
            }

            const apiData = response.data;

            // Process the dynamic form data
            const processedData = this.processDynamicFormData(apiData);

            // Create Excel with dynamic form structure
            this.createDynamicFormExcel(processedData);

            this.setState({ isLoading: false });

        } catch (error) {
            console.error('Error exporting dynamic form Excel data:', error);
            this.swalServices.Error('Failed to export dynamic form data');
            this.setState({ isLoading: false });
        }
    }

    // Process dynamic form data from API response
    processDynamicFormData(apiData) {
        const allQuestions = [];
        const submissionsData = [];
        let formInfo = {};
        const sectionDescriptions = {};

        // First pass: collect all unique questions and form info from all submissions
        apiData.forEach(item => {
            if (item.data && item.data.data && item.data.data.sections) {
                const formData = item.data.data;

                // Collect form information (use first valid entry)
                if (!formInfo.formName && formData.formName) {
                    formInfo = {
                        formName: formData.formName,
                        description: formData.description || ''
                    };
                }

                const sections = formData.sections;

                sections.forEach(section => {
                    // Collect section descriptions
                    if (section.secDescription && !sectionDescriptions[section.sectionName]) {
                        sectionDescriptions[section.sectionName] = section.secDescription;
                    }

                    section.questions.forEach(question => {
                        const questionKey = `${section.sectionName}||${question.question}`;
                        if (!allQuestions.find(q => q.key === questionKey)) {
                            allQuestions.push({
                                key: questionKey,
                                sectionName: section.sectionName,
                                question: question.question,
                                questionId: question.questionId
                            });
                        }
                    });
                });
            }
        });

        // Second pass: extract submission data (without formName in individual rows)
        apiData.forEach(item => {
            if (item.data && item.data.data) {
                const formData = item.data.data;
                const submissionData = {
                    // Removed formName from individual rows - it's now in formInfo section
                    name: formData.name || '',
                    email: formData.email || '',
                    submissionId: item.submissionId
                };

                // Create a map of answers for this submission
                const answersMap = {};
                if (formData.sections) {
                    formData.sections.forEach(section => {
                        section.questions.forEach(question => {
                            const questionKey = `${section.sectionName}||${question.question}`;
                            answersMap[questionKey] = question.answer || '';
                        });
                    });
                }

                // Add answers for all questions (empty if not answered)
                allQuestions.forEach(question => {
                    submissionData[question.key] = answersMap[question.key] || '';
                });

                submissionsData.push(submissionData);
            }
        });

        return {
            questions: allQuestions,
            submissions: submissionsData,
            formInfo: formInfo,
            sectionDescriptions: sectionDescriptions
        };
    }

    // Create Excel for dynamic forms with section-question headers using ExcelJS
    createDynamicFormExcel(processedData) {
        import('exceljs').then((ExcelJS) => {
            const { questions, submissions, formInfo, sectionDescriptions } = processedData;

            // Create workbook and worksheet
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('AHG Submission Data');

            let currentRow = 1;

            // Add form information section at the top
            const formInfoRow = worksheet.addRow(['FORM INFORMATION']);
            formInfoRow.getCell(1).font = { bold: true, size: 14, color: { argb: 'FFFFFFFF' } };
            formInfoRow.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF3B82F6' } };
            formInfoRow.getCell(1).border = {
                top: { style: 'thin', color: { argb: 'FFFFFFFF' } },
                left: { style: 'thin', color: { argb: 'FFFFFFFF' } },
                bottom: { style: 'thin', color: { argb: 'FFFFFFFF' } },
                right: { style: 'thin', color: { argb: 'FFFFFFFF' } }
            };
            currentRow++;

            worksheet.addRow(['Form Name:', formInfo.formName || '']);
            currentRow++;

            worksheet.addRow(['Form Description:', formInfo.description || '']);
            currentRow++;

            worksheet.addRow(['Total Submissions:', submissions.length]);
            currentRow++;

            // Empty row
            worksheet.addRow(['']);
            currentRow++;

            const sectionInfoRow = worksheet.addRow(['SECTION INFORMATION']);
            sectionInfoRow.getCell(1).font = { bold: true, size: 14, color: { argb: 'FFFFFFFF' } };
            sectionInfoRow.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF3B82F6' } };
            sectionInfoRow.getCell(1).border = {
                top: { style: 'thin', color: { argb: 'FFFFFFFF' } },
                left: { style: 'thin', color: { argb: 'FFFFFFFF' } },
                bottom: { style: 'thin', color: { argb: 'FFFFFFFF' } },
                right: { style: 'thin', color: { argb: 'FFFFFFFF' } }
            };
            currentRow++;

            // Add section descriptions
            Object.keys(sectionDescriptions).forEach(sectionName => {
                worksheet.addRow([`${sectionName}:`, sectionDescriptions[sectionName]]);
                currentRow++;
            });

            // Empty row separator
            worksheet.addRow(['']);
            currentRow++;

            // Create header rows
            const headerRow1 = []; // Section names
            const headerRow2 = []; // Questions

            // Add basic columns (without Form Name since it's moved to top)
            headerRow1.push('Name', 'Email');
            headerRow2.push('', ''); // Empty cells under basic column headers

            // Group questions by section
            const sectionGroups = {};
            questions.forEach(question => {
                if (!sectionGroups[question.sectionName]) {
                    sectionGroups[question.sectionName] = [];
                }
                sectionGroups[question.sectionName].push(question);
            });

            // Add section and question headers
            Object.keys(sectionGroups).forEach(sectionName => {
                const sectionQuestions = sectionGroups[sectionName];
                const sectionSpan = sectionQuestions.length;

                // Add section name spanning across its questions
                headerRow1.push(sectionName);
                for (let i = 1; i < sectionSpan; i++) {
                    headerRow1.push('');
                }

                // Add question names under the section
                sectionQuestions.forEach(question => {
                    headerRow2.push(question.question);
                });
            });

            // Add headers to worksheet
            const headerRow1Index = worksheet.addRow(headerRow1).number;
            const headerRow2Index = worksheet.addRow(headerRow2).number;

            // Style header rows
            for (let col = 1; col <= headerRow1.length; col++) {
                const cell1 = worksheet.getCell(headerRow1Index, col);
                const cell2 = worksheet.getCell(headerRow2Index, col);

                // Apply blue background with white text and white borders
                cell1.font = { bold: true, size: 12, color: { argb: 'FFFFFFFF' } };
                cell1.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF3B82F6' } };
                cell1.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
                cell1.border = {
                    top: { style: 'thin', color: { argb: 'FFFFFFFF' } },
                    left: { style: 'thin', color: { argb: 'FFFFFFFF' } },
                    bottom: { style: 'thin', color: { argb: 'FFFFFFFF' } },
                    right: { style: 'thin', color: { argb: 'FFFFFFFF' } }
                };

                cell2.font = { bold: true, size: 12, color: { argb: 'FFFFFFFF' } };
                cell2.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF3B82F6' } };
                cell2.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
                cell2.border = {
                    top: { style: 'thin', color: { argb: 'FFFFFFFF' } },
                    left: { style: 'thin', color: { argb: 'FFFFFFFF' } },
                    bottom: { style: 'thin', color: { argb: 'FFFFFFFF' } },
                    right: { style: 'thin', color: { argb: 'FFFFFFFF' } }
                };
            }

            // Add data rows (without Form Name since it's moved to top)
            submissions.forEach((submission, rowIndex) => {
                const dataRow = [];

                // Add basic data (without Form Name)
                dataRow.push(submission.name, submission.email);

                // Add answers for all questions in order
                questions.forEach(question => {
                    const answer = submission[question.key];

                    // Check if the answer is a signature (base64 image)
                    if (this.isBase64Image(answer)) {
                        // Add clickable signature button
                        dataRow.push('View Signature');
                    } else {
                        dataRow.push(answer);
                    }
                });

                const addedRow = worksheet.addRow(dataRow);

                // Add signature information to cells
                questions.forEach((question, questionIndex) => {
                    const answer = submission[question.key];
                    if (this.isBase64Image(answer)) {
                        this.createSignatureCell(
                            worksheet,
                            addedRow.number,
                            questionIndex + 3, // +3 for Name, Email, and question index
                            answer,
                            submission.submissionId,
                            question.question
                        );
                    }
                });
            });

            // Set column widths
            for (let i = 1; i <= headerRow1.length; i++) {
                worksheet.getColumn(i).width = 20;
            }

            // Add merged cells for section headers
            let mergeStart = 3; // Start after basic columns (Name, Email)

            Object.keys(sectionGroups).forEach(sectionName => {
                const sectionSpan = sectionGroups[sectionName].length;
                if (sectionSpan > 1) {
                    worksheet.mergeCells(headerRow1Index, mergeStart, headerRow1Index, mergeStart + sectionSpan - 1);
                }
                mergeStart += sectionSpan;
            });

            // Create a separate signatures sheet
            this.createSignaturesSheet(workbook, submissions, questions);

            // Generate and save file
            workbook.xlsx.writeBuffer().then(buffer => {
                this.saveAsExcelFile(buffer, 'Dynamic Form Data');
            });
        });
    }

    // Create a separate signatures sheet
    createSignaturesSheet(workbook, submissions, questions) {
        // Find all signatures in the data
        const signatures = [];
        submissions.forEach((submission, submissionIndex) => {
            questions.forEach((question, questionIndex) => {
                const answer = submission[question.key];
                if (this.isBase64Image(answer)) {
                    signatures.push({
                        submissionId: submission.submissionId,
                        name: submission.name,
                        email: submission.email,
                        question: question.question,
                        sectionName: question.sectionName,
                        signatureId: `SIG_${submission.submissionId}_${questionIndex}`,
                        base64Data: answer
                    });
                }
            });
        });
    }

    // Create static form Excel using ExcelJS
    createStaticFormExcelJS(processedData) {
        import('exceljs').then((ExcelJS) => {
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Static Form Data');

            // Get column headers from the first data item
            const headers = Object.keys(processedData[0] || {});

            // Add header row
            const headerRow = worksheet.addRow(headers);

            // Style header row
            for (let col = 1; col <= headers.length; col++) {
                const cell = worksheet.getCell(headerRow.number, col);
                cell.font = { bold: true, size: 12, color: { argb: 'FFFFFFFF' } };
                cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF3B82F6' } };
                cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
                cell.border = {
                    top: { style: 'thin', color: { argb: 'FFFFFFFF' } },
                    left: { style: 'thin', color: { argb: 'FFFFFFFF' } },
                    bottom: { style: 'thin', color: { argb: 'FFFFFFFF' } },
                    right: { style: 'thin', color: { argb: 'FFFFFFFF' } }
                };
            }

            // Add data rows
            processedData.forEach((rowData, rowIndex) => {
                const row = [];
                headers.forEach(header => {
                    const value = rowData[header];
                    if (this.isBase64Image(value)) {
                        row.push(value); // Show the actual base64 data
                    } else {
                        row.push(value);
                    }
                });
                const addedRow = worksheet.addRow(row);

                // Add signature notes
                headers.forEach((header, colIndex) => {
                    const value = rowData[header];
                    if (this.isBase64Image(value)) {
                        this.createSignatureCell(
                            worksheet,
                            addedRow.number,
                            colIndex + 1,
                            value,
                            `Row ${rowIndex + 1}`,
                            header
                        );
                    }
                });
            });

            // Set column widths
            for (let i = 1; i <= headers.length; i++) {
                worksheet.getColumn(i).width = 20;
            }

            // Create signatures sheet if there are any signatures
            const hasSignatures = processedData.some(rowData =>
                Object.values(rowData).some(value => this.isBase64Image(value))
            );

            if (hasSignatures) {
                this.createStaticSignaturesSheet(workbook, processedData, headers);
            }

            // Generate and save file
            workbook.xlsx.writeBuffer().then(buffer => {
                this.saveAsExcelFile(buffer, 'Static Form Data');
            });
        });
    }

    // Create signatures sheet for static forms
    createStaticSignaturesSheet(workbook, processedData, headers) {
        const signatures = [];

        processedData.forEach((rowData, rowIndex) => {
            headers.forEach((header, colIndex) => {
                const value = rowData[header];
                if (this.isBase64Image(value)) {
                    signatures.push({
                        rowIndex: rowIndex + 1,
                        columnName: header,
                        signatureId: `SIG_${rowIndex + 1}_${colIndex}`,
                        base64Data: value
                    });
                }
            });
        });

        if (signatures.length > 0) {
            const signaturesSheet = workbook.addWorksheet('Signatures');

            // Add headers
            const headerRow = signaturesSheet.addRow([
                'Signature ID',
                'Row Number',
                'Column Name',
                'Signature Preview',
                'Base64 Data'
            ]);

            // Style headers
            for (let col = 1; col <= 5; col++) {
                const cell = signaturesSheet.getCell(headerRow.number, col);
                cell.font = { bold: true, size: 12, color: { argb: 'FFFFFFFF' } };
                cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF3B82F6' } };
                cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
            }

            // Add signature data
            signatures.forEach((signature) => {
                const dataRow = signaturesSheet.addRow([
                    signature.signatureId,
                    signature.rowIndex,
                    signature.columnName,
                    '👆 Click to View',
                    signature.base64Data
                ]);

                // Style the preview cell
                const previewCell = signaturesSheet.getCell(dataRow.number, 4);
                previewCell.font = { color: { argb: 'FF0066CC' }, bold: true };
                previewCell.note = 'Copy the Base64 data from column E and paste it in your browser address bar to view the signature.';

                // Add hyperlink to base64 data
                const base64Cell = signaturesSheet.getCell(dataRow.number, 5);
                base64Cell.value = {
                    text: 'Copy Base64 Data',
                    hyperlink: signature.base64Data
                };
                base64Cell.font = { color: { argb: 'FF0000FF' }, underline: true };
            });

            // Set column widths
            signaturesSheet.getColumn(1).width = 20; // Signature ID
            signaturesSheet.getColumn(2).width = 15; // Row Number
            signaturesSheet.getColumn(3).width = 25; // Column Name
            signaturesSheet.getColumn(4).width = 20; // Signature Preview
            signaturesSheet.getColumn(5).width = 50; // Base64 Data

            // Add instructions at the top
            signaturesSheet.spliceRows(1, 0, [
                ['📋 SIGNATURE VIEWING INSTRUCTIONS:'],
                ['1. Find the signature you want to view in the table below'],
                ['2. Copy the Base64 data from column E'],
                ['3. Paste it in your browser address bar to view the signature'],
                ['']
            ]);
        }
    }

    // Create Excel with merged headers using ExcelJS for array fields
    createExcelWithMergedHeadersExcelJS(flattenedData, columns, arrayColumns) {
        import('exceljs').then((ExcelJS) => {
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Submitted Forms');

            // Create header rows
            const headerRow1 = [];
            const headerRow2 = [];

            // Add non-array columns to both header rows
            columns.forEach(col => {
                if (!arrayColumns.includes(col)) {
                    headerRow1.push(col);
                    headerRow2.push('');
                }
            });

            // Add array column headers
            arrayColumns.forEach(arrayCol => {
                headerRow1.push(arrayCol);
                headerRow2.push(''); // Will be filled with property names
            });

            // Add property names for array columns in row 2
            let colIndex = columns.length - arrayColumns.length + 1;
            arrayColumns.forEach(arrayCol => {
                const maxLength = Math.max(...flattenedData.map(item =>
                    Array.isArray(item[arrayCol]) ? item[arrayCol].length : 0
                ));

                for (let i = 0; i < maxLength; i++) {
                    if (i === 0) {
                        headerRow2[colIndex - 1] = `${arrayCol} ${i + 1}`;
                    } else {
                        headerRow2.push(`${arrayCol} ${i + 1}`);
                    }
                }
                colIndex += maxLength;
            });

            // Add headers to worksheet
            const headerRow1Index = worksheet.addRow(headerRow1).number;
            const headerRow2Index = worksheet.addRow(headerRow2).number;

            // Style header rows
            for (let col = 1; col <= headerRow2.length; col++) {
                const cell1 = worksheet.getCell(headerRow1Index, col);
                const cell2 = worksheet.getCell(headerRow2Index, col);

                cell1.font = { bold: true, size: 12, color: { argb: 'FFFFFFFF' } };
                cell1.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF3B82F6' } };
                cell1.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
                cell1.border = {
                    top: { style: 'thin', color: { argb: 'FFFFFFFF' } },
                    left: { style: 'thin', color: { argb: 'FFFFFFFF' } },
                    bottom: { style: 'thin', color: { argb: 'FFFFFFFF' } },
                    right: { style: 'thin', color: { argb: 'FFFFFFFF' } }
                };

                cell2.font = { bold: true, size: 12, color: { argb: 'FFFFFFFF' } };
                cell2.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF3B82F6' } };
                cell2.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
                cell2.border = {
                    top: { style: 'thin', color: { argb: 'FFFFFFFF' } },
                    left: { style: 'thin', color: { argb: 'FFFFFFFF' } },
                    bottom: { style: 'thin', color: { argb: 'FFFFFFFF' } },
                    right: { style: 'thin', color: { argb: 'FFFFFFFF' } }
                };
            }

            // Add data rows
            flattenedData.forEach(rowData => {
                const row = [];
                headerRow2.forEach(header => {
                    row.push(rowData[header] || '');
                });
                worksheet.addRow(row);
            });

            // Set column widths
            for (let i = 1; i <= headerRow2.length; i++) {
                worksheet.getColumn(i).width = 20;
            }

            // Add merged cells for array columns
            let mergeStart = columns.length - arrayColumns.length + 1;
            arrayColumns.forEach(arrayCol => {
                const maxLength = Math.max(...flattenedData.map(item =>
                    Array.isArray(item[arrayCol]) ? item[arrayCol].length : 0
                ));

                if (maxLength > 1) {
                    worksheet.mergeCells(headerRow1Index, mergeStart, headerRow1Index, mergeStart + maxLength - 1);
                }
                mergeStart += maxLength;
            });

            // Generate and save file
            workbook.xlsx.writeBuffer().then(buffer => {
                this.saveAsExcelFile(buffer, 'Submitted Forms');
            });
        });
    }

    // Current Excel export behavior (when no form is selected) using ExcelJS
    exportCurrentExcelData() {
        if (this.dt.current) {
            import('exceljs').then((ExcelJS) => {
                const data = this.state.submittedFormsList;

                const workbook = new ExcelJS.Workbook();
                const worksheet = workbook.addWorksheet('Submitted Forms');

                // Get column definitions from DataTable (same as CSV export)
                let columns = this.dt.current.props.children;
                columns = columns.filter(col => col.props.header !== 'Actions');

                // Extract headers and fields (same as CSV export)
                const headers = columns.map(col => col.props.header);
                const fields = columns.map(col => col.props.field);

                // Add header row
                const headerRow = worksheet.addRow(headers);

                // Style header row
                for (let col = 1; col <= headers.length; col++) {
                    const cell = worksheet.getCell(headerRow.number, col);
                    cell.font = { bold: true, size: 12, color: { argb: 'FFFFFFFF' } };
                    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF3B82F6' } };
                    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
                    cell.border = {
                        top: { style: 'thin', color: { argb: 'FFFFFFFF' } },
                        left: { style: 'thin', color: { argb: 'FFFFFFFF' } },
                        bottom: { style: 'thin', color: { argb: 'FFFFFFFF' } },
                        right: { style: 'thin', color: { argb: 'FFFFFFFF' } }
                    };
                }

                // Add data rows (same structure as CSV export)
                data.forEach(rowData => {
                    const row = fields.map(field => {
                        return rowData[field] !== undefined ? rowData[field] : '';
                    });
                    worksheet.addRow(row);
                });

                // Set column widths
                for (let i = 1; i <= headers.length; i++) {
                    worksheet.getColumn(i).width = 20;
                }

                // Generate and save file
                workbook.xlsx.writeBuffer().then(buffer => {
                    this.saveAsExcelFile(buffer, 'Submitted Forms');
                });
            });
        }
    }

    // Utility function to flatten array fields and create column structure
    flattenArrayFields(data) {
        if (!Array.isArray(data) || data.length === 0) return { flattenedData: [], columns: [], arrayColumns: [] };

        // First pass: analyze all objects to determine the maximum array lengths
        const arrayFieldInfo = {};

        data.forEach(item => {
            Object.keys(item).forEach(key => {
                if (Array.isArray(item[key]) && item[key].length > 0) {
                    if (!arrayFieldInfo[key]) {
                        arrayFieldInfo[key] = { maxLength: 0, properties: new Set() };
                    }

                    arrayFieldInfo[key].maxLength = Math.max(arrayFieldInfo[key].maxLength, item[key].length);

                    // Collect all unique properties from array objects
                    item[key].forEach(arrayItem => {
                        if (typeof arrayItem === 'object' && arrayItem !== null) {
                            Object.keys(arrayItem).forEach(prop => {
                                arrayFieldInfo[key].properties.add(prop);
                            });
                        }
                    });
                }
            });
        });

        // Create column structure
        const columns = [];
        const arrayColumns = [];

        // Add regular fields as columns
        Object.keys(data[0]).forEach(key => {
            if (!Array.isArray(data[0][key])) {
                columns.push({
                    key: key,
                    header: key,
                    isArray: false
                });
            } else {
                // This is an array field
                const arrayInfo = arrayFieldInfo[key];
                if (arrayInfo && arrayInfo.maxLength > 0) {
                    // Create merged header for array field
                    arrayColumns.push({
                        key: key,
                        header: key,
                        isArray: true,
                        maxLength: arrayInfo.maxLength,
                        properties: Array.from(arrayInfo.properties),
                        span: arrayInfo.maxLength * arrayInfo.properties.size
                    });

                    // Create individual columns for each array item and property
                    for (let i = 0; i < arrayInfo.maxLength; i++) {
                        arrayInfo.properties.forEach(prop => {
                            columns.push({
                                key: `${key}_${i}_${prop}`,
                                header: `${key}[${i}].${prop}`,
                                isArray: true,
                                arrayField: key,
                                arrayIndex: i,
                                property: prop
                            });
                        });
                    }
                }
            }
        });

        // Flatten the data
        const flattenedData = data.map(item => {
            const flattened = {};

            Object.keys(item).forEach(key => {
                if (Array.isArray(item[key])) {
                    const arrayInfo = arrayFieldInfo[key];
                    if (arrayInfo && arrayInfo.maxLength > 0) {
                        // Fill array columns with data or empty values
                        for (let i = 0; i < arrayInfo.maxLength; i++) {
                            arrayInfo.properties.forEach(prop => {
                                const columnKey = `${key}_${i}_${prop}`;
                                if (item[key][i] && typeof item[key][i] === 'object' && item[key][i] !== null) {
                                    flattened[columnKey] = item[key][i][prop] || '';
                                } else {
                                    flattened[columnKey] = '';
                                }
                            });
                        }
                    }
                } else {
                    flattened[key] = item[key];
                }
            });

            return flattened;
        });

        return {
            flattenedData,
            columns: columns.filter(col => !col.isArray), // Regular columns
            arrayColumns // Array field information for merged headers
        };
    }

    // Create Excel with merged headers for array fields

    render() {
        if (this.state.route != null) {
            return <Navigate to={this.state.route} />;
        }

        const pageSizes = [5, 10, 20, 50, 100];
        let rowsPerPageOptions = pageSizes.filter(size => size < this.state.totalRecords);

        if (!rowsPerPageOptions.includes(this.state.totalRecords)) {
            rowsPerPageOptions.push(this.state.totalRecords);
        }

        // Determine button label based on form type
        let excelButtonLabel = "Export Excel";
        // let excelButtonTooltip = "Export current table data";
        let csvButtonLabel = "Export CSV";
        // let csvButtonTooltip = "Export current table data";

        if (this.state.filterDetails.formId) {
            const isDynamicForm = this.isDynamicForm(this.state.filterDetails.formId);
            if (isDynamicForm) {
                excelButtonLabel = "Export Detailed Form Excel";
                // excelButtonTooltip = "";
                csvButtonLabel = "Export Detailed Form CSV";
                // csvButtonTooltip = "";
            } else {
                excelButtonLabel = "Export Detailed Form Excel";
                // excelButtonTooltip = "Export detailed form data with array fields";
                csvButtonLabel = "Export Detailed Form CSV";
                // csvButtonTooltip = "Export detailed form data with array fields";
            }
        }

        const paginatorRight = (
            <div className="flex gap-2">
                <Button 
                    label={csvButtonLabel} 
                    icon="pi pi-file" 
                    className="export-btn" 
                    onClick={() => this.exportCSV(false)}
                    // tooltip={csvButtonTooltip}
                    tooltipOptions={{ position: 'top' }}
                />

                <Button
                    label={excelButtonLabel}
                    icon="pi pi-file-excel"
                    className="export-btn"
                    onClick={this.exportExcel}
                    // tooltip={excelButtonTooltip}
                    tooltipOptions={{ position: 'top' }}
                />
            </div>
        );

        return (
            <div className='user-lists'
                style={{ height: "calc((100dvh / 0.85) - 60.8px)" }}
            >
                <div className='user-lists-inner h-full p-[30px]'>
                    <div className='title flex items-center justify-between mb-[10px]'>
                        <h1 className='text-[22px] m-0 font-semibold text-[#004AAD]' style={{ lineHeight: "30px" }}>Submitted Forms</h1>
                    </div>
                    <div className='user-table p-5 bg-white rounded-[16px]' style={{ border: "1px solid #DFDFDF" }}>
                        <div className='table-inner grid grid-cols-4 gap-5 items-end'>
                            <div className="input-grp !mb-0">
                                <label>
                                    Search
                                </label>
                                <InputText
                                    type="search"
                                    value={this.state.globalFilter}
                                    onChange={(e) => this.handleSearch(e.target.value)}
                                    placeholder="Search across all columns..."
                                />
                            </div>
                            <div className="input-grp !mb-0">
                                <label>
                                    Filter by Form
                                </label>
                                <Dropdown
                                    value={this.state.filterDetails.formId}
                                    options={this.state.formList}
                                    optionLabel="label"
                                    optionValue="value"
                                    onChange={(e) => this.handleFormFilter(e.value)}
                                    placeholder="Select form"
                                    showClear
                                    style={{ height: "42px" }}
                                />
                            </div>
                            <div className="input-grp !mb-0">
                                <label>
                                    Filter by Date Range
                                </label>
                                <Calendar
                                    value={this.state.dateRange}
                                    onChange={(e) => this.handleChangeDateRange(e.value)}
                                    selectionMode="range"
                                    placeholder="Select date & time range"
                                    dateFormat="yy-mm-dd"
                                    showTime
                                    hourFormat="24"
                                    stepMinute={10}
                                    numberOfMonths={2}
                                    maxDate={new Date()}
                                    style={{ height: "42px" }}
                                />
                            </div>
                            <Button
                                label="Reset filters"
                                className='w-fit h-fit'
                                onClick={() => this.resetFilter()}
                                style={{ fontWeight: "400", lineHeight: "1" }}
                            />
                        </div>
                        <div className='sub-table rounded-xl shadow-sm overflow-hidden border border-gray-200 bg-white mt-[30px]'>
                            <DataTable
                                value={this.state.submittedFormsList}
                                paginator
                                lazy
                                first={this.state.filterDetails.start}
                                rows={(this.state.totalRecords > this.state.filterDetails.length) ? this.state.filterDetails.length : this.state.totalRecords}
                                totalRecords={this.state.totalRecords}
                                onPage={(e) => this.onPageChange(e)}
                                rowsPerPageOptions={rowsPerPageOptions}
                                responsiveLayout="scroll"
                                scrollable
                                scrollHeight="calc((100dvh / 0.85) - 360px)"
                                className="min-w-full"
                                emptyMessage="No data found"
                                loading={this.state.isLoading}
                                loadingIcon={
                                    <div className="flex justify-center items-center w-full py-4">
                                        <ProgressSpinner style={{ width: '40px', height: '40px' }} strokeWidth="4" />
                                    </div>
                                }
                                onSort={(e) => this.onSortChange(e)}
                                sortField={this.state.filterDetails.sortField}
                                sortOrder={this.state.filterDetails.sortOrder === 'asc' ? 1 : -1}
                                paginatorRight={paginatorRight}
                                ref={this.dt}
                            >
                                <Column
                                    field="srNo"
                                    header="Sr No"
                                    body={(rowData, options) => options.rowIndex + 1}
                                    filterPlaceholder="Search by ID"
                                    headerClassName="bg-blue-50 text-blue-800 font-medium">
                                </Column>
                                <Column
                                    field="formname"
                                    header="Form Type"
                                    sortable
                                    body={this.formTypeBodyTemplate}
                                    filterPlaceholder="Search by form"
                                    headerClassName="bg-blue-50 text-blue-800 font-medium">
                                </Column>
                                <Column
                                    field="name"
                                    header="Candidate Name"
                                    sortable
                                    filterPlaceholder="Search by name"
                                    headerClassName="bg-blue-50 text-blue-800 font-medium">
                                </Column>
                                <Column
                                    field="email"
                                    header="Candidate Email"
                                    sortable
                                    filterPlaceholder="Search by email"
                                    // filterFunction={this.filterByDateRange}
                                    // filterElement={this.dateRangeFilterTemplate}
                                    headerClassName="bg-blue-50 text-blue-800 font-medium">
                                </Column>
                                <Column
                                    field="uniquePAYEId"
                                    header="PAYE ID"
                                    sortable
                                    filterPlaceholder="Search by PAYE ID"
                                    // filterFunction={this.filterByDateRange}
                                    // filterElement={this.dateRangeFilterTemplate}
                                    headerClassName="bg-blue-50 text-blue-800 font-medium">
                                </Column>
                                <Column
                                    field="createddate"
                                    header="Submitted Date"
                                    sortable
                                    filterPlaceholder="Search by createddate"
                                    headerClassName="bg-blue-50 text-blue-800 font-medium">
                                </Column>
                                <Column
                                    header="Actions"
                                    body={this.actionBodyTemplate}
                                    style={{ textAlign: 'center', width: '10rem' }}
                                    headerClassName="bg-blue-50 text-blue-800 font-medium centered-header"
                                />
                            </DataTable>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}